import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoacabpackage() {



const cardData =
{
  keyword: 'Pune to Goa Cab Package   ',

  heading: 'Lotus Cab: Pune to Goa Cab Package   ',

headingDescription:
  "Lotus Cabs offers customized Pune to Goa Cab Package services for family vacations, group tours, corporate trips, weekend getaways, sightseeing plans, and holiday travel. Our packages are designed to provide a comfortable and convenient journey with flexible one-way and round-trip options. Choose from our premium fleet of Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus, all driven by professional and experienced chauffeurs. With 24x7 booking support, transparent pricing, doorstep pickup from any location in Pune, well-maintained vehicles, and safe highway travel, Lotus Cabs ensures a memorable, smooth, and hassle-free Pune to Goa cab package experience.",



  top: 'Top Places to Visit in Goa before Traveling to Pune with Lotus Cab',

topPlaces: [
  
    {
        title: "Se Cathedral",
        description:
            "Se Cathedral is one of the largest churches in Asia and a remarkable example of Portuguese-Gothic architecture. Dedicated to Saint Catherine, the cathedral is admired for its grand interiors, historic significance, and the famous Golden Bell."
    },
    {
        title: "Church of Our Lady of the Immaculate Conception",
        description:
            "Located in Panaji, the Church of Our Lady of the Immaculate Conception is famous for its iconic white façade, elegant stairways, and centuries-old history. It is one of Goa's most photographed landmarks and offers beautiful views of the city."
    },
    {
        title: "Butterfly Beach",
        description:
            "Butterfly Beach is a secluded paradise surrounded by lush forests and crystal-clear waters. Accessible mainly by boat or trekking, the beach is ideal for travelers seeking tranquility, dolphin sightings, and breathtaking natural beauty."
    },
      {
        title: "Vagator Beach",
        description:
            "Vagator Beach is a scenic coastal destination known for its dramatic red cliffs, soft golden sand, and breathtaking sunsets over the Arabian Sea. The beach offers a peaceful atmosphere, trendy cafés, and stunning viewpoints, making it a favorite among photographers and couples."
    },
    {
        title: "Colva Beach",
        description:
            "Colva Beach is one of South Goa's most beautiful beaches, stretching for several kilometers with soft white sand and swaying coconut palms. Visitors enjoy swimming, beach walks, water sports, seafood restaurants, and a relaxing coastal ambiance."
    },
    {
        title: "Arambol Beach",
        description:
            "Arambol Beach is popular for its bohemian vibe, live music, yoga retreats, and vibrant beachside cafés. The beach attracts backpackers and international travelers looking for a laid-back atmosphere and unforgettable sunset views."
    },
    {
        title: "Divar Island",
        description:
            "Divar Island is a peaceful river island that showcases Goa's traditional village life, Portuguese-era churches, scenic landscapes, and lush paddy fields. Visitors enjoy ferry rides, cycling, and exploring the island's rich cultural heritage."
    },
    {
        title: "Naval Aviation Museum",
        description:
            "The Naval Aviation Museum in Vasco da Gama displays vintage aircraft, helicopters, engines, and naval artifacts that highlight the history of the Indian Navy's aviation wing. It is an educational attraction for families and aviation enthusiasts."
    },
    {
        title: "Mollem National Park",
        description:
            "Mollem National Park is a biodiversity hotspot located in the Western Ghats, home to diverse wildlife, dense forests, waterfalls, and numerous trekking trails. Nature lovers visit the park to experience Goa's rich flora and fauna."
    },
    {
        title: "Fontainhas",
        description:
            "Fontainhas is Goa's charming Latin Quarter, famous for its colorful Portuguese-style houses, narrow winding streets, art galleries, cafés, and vibrant cultural heritage. Walking through this picturesque neighborhood offers a glimpse into Goa's colonial past."
    }
],





"services": [
  {
    "name": "Pune to Goa Cab Package",
    "description": "Book a Pune to Goa cab package for comfortable intercity travel with customized itineraries, professional drivers, and multiple vehicle options."
  },
  {
    "name": "Pune to Goa Taxi Package",
    "description": "Reliable Pune to Goa taxi package offering affordable travel plans for families, tourists, and corporate travelers."
  },
  {
    "name": "Pune to Goa Tour Package by Cab",
    "description": "Enjoy a Pune to Goa tour package by cab with convenient transportation, flexible schedules, and comfortable sightseeing trips."
  },
  {
    "name": "Pune to Goa Family Cab Package",
    "description": "Pune to Goa family cab package designed for group and family vacations with spacious vehicles and comfortable travel arrangements."
  },
  {
    "name": "Pune to Goa One Way Cab Package",
    "description": "Affordable Pune to Goa one way cab package allowing passengers to travel conveniently without return journey charges."
  },
  {
    "name": "Pune to Goa Round Trip Cab Package",
    "description": "Flexible Pune to Goa round trip cab package ideal for weekend getaways, holidays, and business travel."
  },
  {
    "name": "Pune to Goa Holiday Cab Package",
    "description": "Pune to Goa holiday cab package offering comfortable transportation and customized travel plans for memorable vacations."
  },
  {
    "name": "Pune to Goa Outstation Cab Package",
    "description": "Reliable Pune to Goa outstation cab package with experienced drivers and well-maintained vehicles for long-distance travel."
  },
  {
    "name": "Pune to Goa Innova Package",
    "description": "Premium Pune to Goa Innova package featuring spacious seating and enhanced comfort for family and group travel."
  },
  {
    "name": "Pune to Goa Ertiga Package",
    "description": "Affordable Pune to Goa Ertiga package suitable for small groups and families seeking comfortable travel."
  },
  {
    "name": "Pune to Goa Sedan Cab Package",
    "description": "Economical Pune to Goa sedan cab package ideal for couples, solo travelers, and small families."
  },
  {
    "name": "Pune to Goa Cab Tour",
    "description": "Book a Pune to Goa cab tour for a relaxing journey with flexible stops and personalized travel experiences."
  },
  {
    "name": "Pune to Goa Travel Package",
    "description": "Comprehensive Pune to Goa travel package including comfortable transportation and customizable travel plans."
  },
  {
    "name": "Pune to Goa Sightseeing Cab Package",
    "description": "Pune to Goa sightseeing cab package offering convenient transportation to popular beaches and tourist attractions."
  },
  {
    "name": "Pune to Goa Weekend Package",
    "description": "Enjoy a Pune to Goa weekend package with flexible cab options and comfortable travel arrangements for short vacations."
  },
  {
    "name": "Pune to Goa Package for Family",
    "description": "Special Pune to Goa package for family trips with spacious vehicles and customized itineraries for a hassle-free holiday."
  },
  {
    "name": "Pune to Goa Cab Booking Package",
    "description": "Easy Pune to Goa cab booking package with instant confirmation and multiple vehicle choices to suit your travel needs."
  },
  {
    "name": "Pune to Goa Affordable Cab Package",
    "description": "Budget-friendly Pune to Goa affordable cab package offering quality service and competitive pricing."
  },
  {
    "name": "Best Pune to Goa Cab Package",
    "description": "Best Pune to Goa cab package featuring professional drivers, clean vehicles, and exceptional customer service."
  }
],

"tableData": [
  ["Pune to Goa Cab Package", "Pune to Goa Taxi Package"],
  ["Pune to Goa Tour Package by Cab", "Pune to Goa Family Cab Package"],
  ["Pune to Goa One Way Cab Package", "Pune to Goa Round Trip Cab Package"],
  ["Pune to Goa Holiday Cab Package", "Pune to Goa Outstation Cab Package"],
  ["Pune to Goa Innova Package", "Pune to Goa Ertiga Package"],
  ["Pune to Goa Sedan Cab Package", "Pune to Goa Cab Tour"],
  ["Pune to Goa Travel Package", "Pune to Goa Sightseeing Cab Package"],
  ["Pune to Goa Weekend Package", "Pune to Goa Package for Family"],
  ["Pune to Goa Cab Booking Package", "Pune to Goa Affordable Cab Package"],
  ["Best Pune to Goa Cab Package", ""]
],






"whychoose": [
  {
    "WhyChooseheading": "Customized Cab Packages",
    "WhyChoosedescription": "Choose flexible Pune to Goa cab packages designed for families, couples, and group travelers."
  },
  {
    "WhyChooseheading": "Budget-Friendly Travel Plans",
    "WhyChoosedescription": "Affordable package options with transparent pricing and no hidden charges."
  },
  {
    "WhyChooseheading": "One Way & Round Trip Packages",
    "WhyChoosedescription": "Book packages for a single journey or enjoy a complete Goa vacation with return travel."
  },
  {
    "WhyChooseheading": "Wide Selection of Vehicles",
    "WhyChoosedescription": "Select from Sedan, Ertiga, Innova Crysta, and SUVs according to your travel requirements."
  },
  {
    "WhyChooseheading": "Doorstep Pickup in Pune",
    "WhyChoosedescription": "Convenient pickup service from homes, hotels, offices, airports, and railway stations."
  },
  {
    "WhyChooseheading": "Comfortable Long-Distance Ride",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and well-maintained vehicles for a relaxing trip."
  },
  {
    "WhyChooseheading": "Experienced Drivers",
    "WhyChoosedescription": "Professional chauffeurs ensure safe and smooth travel through highways and ghat sections."
  },
  {
    "WhyChooseheading": "24/7 Booking Support",
    "WhyChoosedescription": "Get assistance anytime for package details, bookings, and travel-related queries."
  }
]
};

const faqData = [
  {
    question: 'Does Lotus Cab provide Pune to Goa cab packages?',
    answer: 'Yes, Lotus Cab offers affordable Pune to Goa cab packages for one-way trips, round trips, and customized vacation plans.'
  },
  {
    question: 'What is included in the Pune to Goa cab package?',
    answer: 'The package includes a comfortable cab, professional driver, and flexible travel options. Additional charges such as tolls and parking may apply separately.'
  },
  {
    question: 'What is the distance between Pune and Goa?',
    answer: 'The distance from Pune to Goa is approximately 450 km, and the journey usually takes around 8 to 10 hours depending on traffic and route conditions.'
  },
  {
    question: 'Can I book a round-trip Goa package?',
    answer: 'Yes, we offer round-trip packages that are ideal for weekend getaways, family vacations, and business travel.'
  },
  {
    question: 'Which vehicles are available in the cab package?',
    answer: 'You can choose from Sedan cars, Ertiga, Innova Crysta, and SUVs based on the number of passengers and luggage requirements.'
  },
  {
    question: 'Do you provide pickup from Pune Airport and railway station?',
    answer: 'Yes, Lotus Cab provides pickup services from Pune Airport, railway stations, hotels, and residential areas.'
  },
  {
    question: 'Are toll and parking charges included in the package fare?',
    answer: 'Toll charges, parking fees, and state taxes are generally charged separately unless specifically mentioned in the package.'
  },
  {
    question: 'Can I customize my Pune to Goa cab package?',
    answer: 'Yes, we offer customized travel packages according to your schedule, duration of stay, and vehicle preference.'
  },
  {
    question: 'Is night travel available under the cab package?',
    answer: 'Yes, our Pune to Goa cab packages are available for both daytime and overnight departures.'
  },
  {
    question: 'How can I book a Pune to Goa Cab Package with Lotus Cab?',
    answer: 'Simply share your travel date, pickup location, number of passengers, and preferred vehicle to receive package details and instant confirmation.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Deshpande',
    feedback: 'Our Goa vacation package was perfectly arranged by Lotus Cab. The driver was courteous and the journey felt comfortable right from the start.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Pooja Sharma',
    feedback: 'We wanted a complete travel solution for our group trip to Goa, and this cab package turned out to be a great choice. Spacious vehicle and timely service throughout the journey.',
    rating: 5,
  },
];









































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Goa Cab Package",
"image": "https://lotuscab.com/assets/images/pune-to-goa-cab-package.jpg",
"description": "Book Pune to Goa Cab Package with Lotus Cab for comfortable and convenient holiday travel. Enjoy family cab packages, one way and round trip packages with sedan, Innova, Ertiga, and SUV cabs for Goa tours with professional drivers and 24x7 taxi service.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7215"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹18/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-goa-cab-package"
}
};



  return (
    <div>
      



<Helmet>
  <title>Pune to Goa Cab Package | Family & Outstation Taxi Package | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Goa Cab Package with Lotus Cab for a comfortable and affordable Goa tour. Get family, holiday, one way, and round trip cab packages with Innova, Ertiga, sedan, and SUV cabs driven by professional drivers."
/>

<meta
 name="keywords"
 content="Pune to Goa Cab Package, Pune to Goa Taxi Package, Pune to Goa Tour Package by Cab, Pune to Goa Family Cab Package, Pune to Goa One Way Cab Package, Pune to Goa Round Trip Cab Package, Pune to Goa Holiday Cab Package, Pune to Goa Outstation Cab Package, Pune to Goa Innova Package, Pune to Goa Ertiga Package, Pune to Goa Sedan Cab Package, Pune to Goa Cab Tour"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/97.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoacabpackage;